// src/RTK/store.js (or your store setup file)
import { configureStore } from "@reduxjs/toolkit";
import productReducer from "./productSlice"; // Your existing product slice
import productDetailsReducer from "./productDetailsSlice"; // New product details slice
import agentsReducer from "./AgentsSlice"
import CategoriesSlice from "./categories/GetCategories"

import categoriesReducer from './categories/UpdatecategorySlice';
import CreatReducer from './categories/CreateCategories';
import usersReducer from './users/GetAllUsers';
import userUpdateReducer from './users/updateUser ';
import ordersReducer from './orders/GetAllOrders'; 
import allagentsReducer from './agents/GetAgents'; 
import userLevelsReducer from './userlevels/GetAll'; 
import transactionsReducer from './transaction/GetTransaction'; 

import dashboardReducer from './dashboard/Dashboard'; 
import notificationReducer from './users/sendNotification '; 
import notificationReducerReducer from './users/sendNotification '; 
import  paymentMethodsReducer from './Payment-methods/GetAllPaymentMMethods'; 
import  expensesSummaryReducer from './ExpensesSummary/GetExpensesSummary'; 
import  expenseManagementReducer from './ExpensesSummary/CreateExpense'; 
import  causeTypesReducer from './ExpensesSummary/CauseTypes'; 
import  voucherReducer from './voucherSlice'; 
import  searchReducer from './SearchBare/Searchbar'; 
import  bannerReducer from './categories/BannerSlice'; 
import  authReducer from './login/Authentication'; 
import  settingsReducer from './settings/Settings'; 
import employeesReducer from "./employees/GetEmployees";
import permissionsReducer from "./employees/GetPermissions";
import activityLogsReducer from "./activityLogs/GetActivityLogs";
import userFinancialReducer from "./users/userSlice"; 
import agentProductsReducer from "./agents/AgentProducts";
import userCustomPricingReducer from "./users/userCustomPricingSlice";

export const store = configureStore({
  reducer: {
    products: productReducer,
    productDetails: productDetailsReducer, 
    agents: agentsReducer,
    categories: CategoriesSlice,
    updatecategories: categoriesReducer,
    createcategories:CreatReducer,
    users: usersReducer,
    userCustomPricing: userCustomPricingReducer,
    userUpdate: userUpdateReducer,
    orders: ordersReducer,
    allagents: allagentsReducer,
    userLevels: userLevelsReducer,
    transactions: transactionsReducer,
    dashboard: dashboardReducer,
    notifications: notificationReducer,
    notificationsAllUsers: notificationReducerReducer,
    paymentMethods: paymentMethodsReducer,
    expenseManagement: expenseManagementReducer,
    expensesSummary: expensesSummaryReducer,
    causeTypes: causeTypesReducer,
    vouchers: voucherReducer,
    search: searchReducer,
    banners: bannerReducer,
    auth: authReducer,
    settings: settingsReducer,
    employees: employeesReducer,
    permissions: permissionsReducer,
    activityLogs: activityLogsReducer,
    userFinancial: userFinancialReducer, 
    agentProducts: agentProductsReducer,


    },
});


